import React, { memo, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { cn } from '@lux/core';
import { useConfig } from '@browsing/config';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { Translate } from '@pegasus/translation';
import { trackSelectContent, trackViewContent } from '@browsing/tracking';
import { InView } from 'react-intersection-observer';
import { ChatBox } from './chat-box';
import { ScrollToTopButton, ScrollToTopButtonContainer } from '../scroll-to-top-button';
var PLUS_CTA_THRESHOLD = 315;
var PLUS_DEBOUNCE_TIME = 10;
export var BottomBubble = memo(function (_a) {
    var children = _a.children, customer = _a.customer, loyaltyEAVariant = _a.loyaltyEAVariant, onPlusCtaClick = _a.onPlusCtaClick;
    var config = useConfig();
    // Initialize to false - this is important for ensuring it's hidden by default
    var _b = useState(false), isPlusCTAOpen = _b[0], setIsPlusCTAOpen = _b[1];
    useEffect(function () {
        if (!loyaltyEAVariant) {
            return;
        }
        var onScroll = debounce(function () {
            if (window.scrollY > PLUS_CTA_THRESHOLD) {
                setIsPlusCTAOpen(true);
            }
            else {
                setIsPlusCTAOpen(false);
            }
        }, PLUS_DEBOUNCE_TIME);
        window.addEventListener('scroll', onScroll);
        // We don't trigger the check on initial mount to ensure it starts hidden
        return function () {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    var handleTurnOnPlusCtaClick = function () {
        if (!onPlusCtaClick) {
            return;
        }
        trackSelectContent('loyalty_opt_in_footer', 'click', {
            contentId: 'turn_on_plus',
        });
        onPlusCtaClick();
    };
    var trackImpression = function (inView, loyaltyEAVariant) {
        if (!loyaltyEAVariant || !inView) {
            return;
        }
        trackViewContent('loyalty_opt_in_footer', 'view');
    };
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement(ScrollToTopButtonContainer, { "$isCTAOpen": isPlusCTAOpen },
            config.isEnabled('livechat') && React.createElement(ChatBox, { customer: customer }),
            React.createElement(ScrollToTopButton, null)),
        loyaltyEAVariant && (React.createElement("div", { key: "plus-cta", className: cn('bg-function-0 fixed inset-x-0 bottom-0 z-[1000]', 'px-sm pt-xs pb-l', 'shadow-[0px_-2px_6px_rgba(0,0,0,0.08)]', isPlusCTAOpen ? 'block sm:hidden' : 'hidden', isPlusCTAOpen ? 'animate-slideIn' : 'animate-slideOut') },
            React.createElement(InView, { as: "div", onChange: function (inView) { return trackImpression(inView, loyaltyEAVariant); }, triggerOnce: true, threshold: 0.9 },
                React.createElement(Button, { buttonType: ButtonType.primary, style: { width: '100%' }, color: ButtonColor.dark, onClick: handleTurnOnPlusCtaClick },
                    React.createElement(Translate, { message: "plus.cta" })))))));
});
